import {getExportStylesFromColumnCb} from "../styles/getExportStylesFromColumn";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {Row} from "exceljs";
import {GenerateExportExcelRowStylesCb} from "@ui/tableCustom/types/table";
import {buildStylesExcelJs} from "../styles/buildStylesExcelJs";

export const buildStylesRowExcelJs = <T>({
                                             columns,
                                             rowExcelJs,
                                             generateExportExcelRowStylesCb,
                                             content,
                                         }: {
    columns: IColumnItem<T>[],
    rowExcelJs: Row,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>,
    content: T
}) => {
    columns.forEach((column, index) => {
        if (column.hideExport) {
            return;
        }
        const columnNumber = index + 1;
        const exportStyles = generateExportExcelRowStylesCb ? generateExportExcelRowStylesCb({
            column,
            content
        }) : getExportStylesFromColumnCb(column)

        if (!exportStyles) {
            return
        }
        const cell = rowExcelJs.getCell(columnNumber);
        buildStylesExcelJs({
            cell,
            exportStyles
        })

    });
}